import SaveToWorkspace from '@patsnap-biz/save-to-workspace-v2'
import { defineComponent, getCurrentInstance, onUnmounted, ref } from '@vue/composition-api'
import { workspaceComponentProps } from '../../type'
import $classes from '../Workspace.module.scss'
import SavePaperService from './SavePaperService'

const { SavePaperToWorkspace } = SaveToWorkspace

export const PaperWorkspace = defineComponent({
  name: 'PaperWorkspace',
  props: workspaceComponentProps(),
  setup(props) {
    const instance = getCurrentInstance()
    const PaperService = ref()

    PaperService.value = new SavePaperService({ vm: instance?.proxy, ...props })

    const close = () => {
      PaperService.value = null
    }

    onUnmounted(close)

    return {
      PaperService,
    }
  },
  render() {
    if (this.PaperService) {
      return <SavePaperToWorkspace service={this.PaperService} append-to-body class={$classes.workspace}></SavePaperToWorkspace>
    }
    return <span></span>
  },
})
